import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthentificationService } from '@core/services/authentification/authentification.service';
import { UserService } from '@core/services/user/user.service';
import { AppRoutes } from '../routes/route.paths';
import { AppService } from '@core/services/app.service';

export const authGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authentificationService = inject(AuthentificationService);
  const userService = inject(UserService);
  const router = inject(Router);
  const appService = inject(AppService);

  // If user is not authenticated
  if (!authentificationService.isLoggedIn()) {
    router.navigateByUrl(AppRoutes.Auth.root);
    return false;
  }

  const superUserRoutes: string[] = [
    AppRoutes.Customers.root,
    AppRoutes.Configuration.root,
    AppRoutes.Supervision.Global,
    AppRoutes.Admin.root,
    AppRoutes.ConfigGeneral.root,
    AppRoutes.Validator.root,
  ];

  let currentUrl = !state.url.startsWith('/') ? `/${state.url}` : state.url;
  // For route under acces-ged, just take acces-ged for url_access_rights
  if (currentUrl.includes(AppRoutes.AccesGed.root)) {
    currentUrl = AppRoutes.AccesGed.root;
  }

  if (userService.isSuperUser() && superUserRoutes.some((route) => currentUrl.startsWith(route))) {
    return true;
  }

  // Special handling for SSO routes
  if (currentUrl.startsWith(AppRoutes.Sso.root)) {
    if (!userService.checkSsoAccess()) {
      router.navigateByUrl(AppRoutes.Welcome);

      return false;
    }
    return true;
  }

  const authorized =
    userService.checkAccessRights(currentUrl?.split('?')[0]) ||
    currentUrl === AppRoutes.Welcome ||
    currentUrl === AppRoutes.ValiderPlis ||
    currentUrl === AppRoutes.Profil ||
    (currentUrl === AppRoutes.Clients.root && !userService.isSupport() && appService.clientLinkExists());

  if (!authorized) {
    router.navigateByUrl(AppRoutes.Welcome);
  }

  return true;
};
